import { set, toggle } from '@/utils/vuex'

export default {
  // setSpecialModelTestList (state, data) {
  //   state.specialModelTestList = data
  // },

}
